module.exports = __webpack_public_path__ + "static/media/promo.3b0fb05a.webp";